(() => {
  if(customElements.get('fashion-size-guide'))return;
  class FashionSizeGuide extends HTMLElement {
    connectedCallback(){
      this.onClick=e=>{
        const unit=e.target.closest('[data-chart-unit]');
        if(unit&&this.contains(unit))this.setUnit(unit.dataset.chartUnit);
        const open=e.target.closest('[data-fashion-chart-open]');
        const targetDialog=this.querySelector('dialog');
        if(open&&targetDialog&&open.getAttribute('aria-controls')===targetDialog.id){e.preventDefault();this.opener=open;targetDialog.showModal();}
        if(e.target.closest('[data-fashion-chart-close]')&&this.contains(e.target))this.querySelector('dialog').close();
      };
      document.addEventListener('click',this.onClick);
      const dialog=this.querySelector('dialog');
      dialog?.addEventListener('close',()=>this.opener?.focus());
      dialog?.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      this.observer=new MutationObserver(()=>this.place());
      this.observer.observe(document.body,{childList:true,subtree:true});
      this.place();
      this.setUnit(this.dataset.country==='US'?'in':'cm');
    }
    setUnit(unit){
      const source=this.dataset.sourceUnit;
      const sourceIn=['in','inch','inches'].includes(source);
      if(!sourceIn&&source!=='cm')return;
      const factor=sourceIn?(unit==='cm'?2.54:1):(unit==='in'?1/2.54:1);
      const format=new Intl.NumberFormat(this.dataset.locale||'en',{maximumFractionDigits:2});
      this.querySelectorAll('[data-measure-value]').forEach(cell=>{
        const raw=cell.dataset.measureValue.trim();
        // Convert only plain measurements/ranges, never sizes, UK/US codes or unknown text.
        cell.textContent=/^\d+(?:[.,]\d+)?(?:\s*[-–]\s*\d+(?:[.,]\d+)?)?$/.test(raw)
          ?raw.replace(/\d+(?:[.,]\d+)?/g,n=>format.format(Number(n.replace(',','.'))*factor)):raw;
      });
      const names={fr:'po',it:'pollici',pl:'cale'};
      const label=unit==='cm'?'cm':(names[this.dataset.locale?.slice(0,2)]||'in');
      this.querySelectorAll('[data-measure-unit]').forEach(el=>el.textContent=`(${label})`);
      this.querySelectorAll('[data-chart-unit]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.chartUnit===unit)));
    }
    disconnectedCallback(){this.observer?.disconnect();document.removeEventListener('click',this.onClick);}
    place(){
      const nova=document.querySelector('.product-information variant-picker');
      const hale=document.querySelector('.product-single__meta');
      const root=nova||hale;if(!root)return;
      const index=Number(this.dataset.optionIndex)-1;
      const groups=nova?root.querySelectorAll('.variant-option'):root.querySelectorAll('.variant-wrapper');
      let group=groups[index];if(!group)return;
      let label=group.querySelector(nova?'legend, :scope > label':'.variant__label');
      const appLabel=hale?.querySelector(`.swatch-label #option${index+1}`)?.closest('label');
      if(!nova&&appLabel){label=appLabel;group=appLabel.closest('.fashion-size-heading')?.parentElement||appLabel.parentElement;}
      if(!label)return;
      if(this.querySelector('[data-guide-trigger]')&&!group.querySelector('[data-fashion-chart-open]')){
        let row=label;
        if(label.tagName==='LABEL'){
          row=label.parentElement.classList.contains('fashion-size-heading')?label.parentElement:document.createElement('div');
          if(!row.parentElement){label.before(row);row.append(label);}
        }
        row.classList.add('fashion-size-heading');
        const existing=root.querySelector('[data-fashion-chart-open]');
        row.append(existing||this.querySelector('[data-guide-trigger]').content.cloneNode(true));
      }
      // Keep the scale after the complete size choices, including app-rendered choices.
      const fitAnchor=appLabel?.closest('fieldset')||group;
      const fit=root.querySelector('.hale-fit,.fashion-fit');
      const fitTemplate=this.querySelector('[data-guide-fit]');
      if(!fitTemplate){fit?.remove();return;}
      if(!fit)fitAnchor.after(fitTemplate.content.cloneNode(true));
      else if(fitAnchor.nextElementSibling!==fit)fitAnchor.after(fit);
    }
  }
  customElements.define('fashion-size-guide',FashionSizeGuide);
})();
